/**
 * Single source of truth for the GraphQL backend URL.
 * Used by the /api/graphql proxy and by server-side GraphQL calls (SSR, codegen).
 * Browser code always uses same-origin /api/graphql and never hits this.
 */
export function getBackendGraphqlUrl(): string {
  const base =
    process.env.NEXT_PUBLIC_VI_API_URL?.trim() || process.env.VI_API_URL?.trim()

  if (!base) {
    throw new Error('NEXT_PUBLIC_VI_API_URL (or VI_API_URL) is not defined')
  }

  return `${base}/graphql/`
}
